import {ModalBody, ModalHeader, ModalTitle} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import style from "../CardsModal.module.css"
import {useState} from "react";
import ZoomImage from "../ZoomImage";
import * as UserService from "../../api/UserService";
import SelectedCard from "./SelectedCard";
import {useTranslation} from "react-i18next";

function MetaphoricCardsModal(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'metaphoricCardsModal' });
    const [selectedCardNumber, setSelectedCardNumber] = useState(0)
    const [selectedCardIdx, setSelectedCardIdx] = useState(0)
    const max = props.selectedStackData.number_of_cards
    const min = 1

    function getRandomCard() {
        let num = Math.floor(Math.random() * (max - min + 1)) + min
        setSelectedCardNumber(num)
        let imageUrl = props.selectedStackData.card_img_url_prefix + num + props.selectedStackData.card_img_url_extension

        UserService.saveSelectedMetaphoricCard(props.gameId, props.selectedStackData.id, num, imageUrl,
            () => {
            }, () => {
            })
    }

    let cardSelectedElement = (cardLink, className) => {
        return (
            <SelectedCard
                selectedCardClassName={className}
                selectedCardlink={cardLink}
                selectedStackData={props.selectedStackData}
            />
        )
    }

    let cardElement = (cardLink, doOnClick) => {
        return (<img src={cardLink}
                     onClick={doOnClick}
                     className={selectedCardIdx !== 0 ? style.cardNotSelected : style.cardsDefaultBorder}
                     alt={"Not found"}
                     onContextMenu={(evt) => {evt.preventDefault()}}
                     onDragStart={(event) => {
                         event.preventDefault()
                         return false
                     }}
        />)
    }

    function getCardClassName(num) {
        switch (num) {
            case 1: return "first";
            case 2: return "second";
            case 3: return "third";
            default: return "first"
        }
    }

    function cardNElement(n) {
        return (
            (selectedCardIdx === n)
                ?
                <ZoomImage image={
                    cardSelectedElement(
                        props.selectedStackData.card_img_url_prefix + selectedCardNumber + props.selectedStackData.card_img_url_extension,
                        getCardClassName(n))
                }></ZoomImage>
                :
                cardElement(props.selectedStackData.title_card_img, () => {
                    setSelectedCardIdx(n)
                    getRandomCard()
                })
        )
    }

    return (
        <>
            <Modal
                show={true}
                onHide={props.closeModal}
            >
                <ModalHeader closeButton>
                    <ModalTitle>{t('selectCard')}</ModalTitle>
                </ModalHeader>

                <ModalBody>
                    <div className={style.cardsModal}>
                        {cardNElement(1)}
                        {cardNElement(2)}
                        {cardNElement(3)}
                    </div>

                </ModalBody>
            </Modal>
        </>
    )
}

export default MetaphoricCardsModal